import type { LockTokenId } from "@/types/token.types";
import { DialogContent, LockForm } from "@/components";

export interface LockFormDialogProps {
    onClose?: () => void;
    initialLockAmount?: number;
    initialDuration?: number;
    initialTokenId?: LockTokenId;
}

export function LockFormDialog({ initialLockAmount, initialDuration, initialTokenId }: LockFormDialogProps) {
    return (
        <DialogContent>
            <LockForm
                initialAmount={initialLockAmount}
                initialDuration={initialDuration}
                initialTokenId={initialTokenId}
                isDialog
            />
        </DialogContent>
    );
}
